import { defineComponent as _defineComponent } from 'vue'
import Wizard from '../wizard/Wizard.vue';
import CustomersListSelectorWizardStep from './CustomersListSelectorWizardStep.vue';
import EquipmentListSelectorWizardStep from './EquipmentListSelectorWizardStep.vue';
import KpiSelectionFormWizardStep from './KpiSelectionFormWizardStep.vue';
import VariableSelectionFormWizardStep from './VariableSelectionFormWizardStep.vue';
import SourceSelectionFormWizardStep from './SourceSelectionFormWizardStep.vue';
import EventCodesSelectionFormWizardStep from './EventCodesSelectionFormWizardStep.vue';
import { AlertOperator, CareAlertMetric } from '@/models/enums/AlertsEnums';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { isEmpty } from '@/utils/misc';
import { computed, reactive } from 'vue';
import { alertsService } from '@/services/alerts.service';
import { CareAlertFormData } from './model';
import { useI18n } from '@/composables/i18n';
import { CareAlertType } from '@/models/enums/CareAlertType';


export default /*#__PURE__*/_defineComponent({
  __name: 'CareAlertCreationWizard',
  emits: ['save', 'close'],
  setup(__props, { emit }) {



const formData: CareAlertFormData = reactive({
  customers: [],
  devices: [],
  kpi: null,
  operator: AlertOperator.None,
  threshold: null,
  dateGrouping: FilterTimeAxisSpanEnum.None,
  variable: null,
  sources: [],
  eventCodes: [],
});

const { t } = useI18n();

function onKpiSelectionFormInput(value: CareAlertFormData) {
  Object.assign(formData, value);
}

async function onSubmit() {
  const alertDefinition = {
    type: CareAlertType.Custom as const,
    deviceIds: formData.devices.map((device) => device.id),
    metric: formData.kpi!.kpi,
    operator: formData.operator,
    threshold: +formData.threshold!,
    dateGrouping: formData.dateGrouping,
    variable: kpiRequiresVariable.value ? formData.variable : null,
    eventSources: kpiRequiresSource.value ? formData.sources : [],
    eventCodes: kpiRequiresEventCode.value ? formData.eventCodes : [],
  };

  return await alertsService.createMultiple(alertDefinition).then(() => {
    emit('save');
    emit('close');
  });
}

function onVariableSelectionEnter() {
  formData.eventCodes = [];
  formData.sources = [];
}

async function onSourceSelectionEnter() {
  formData.eventCodes = [];
  formData.variable = null;
}

const selectedTenantIds = computed(() =>
  formData.customers.map((customer) => customer.id),
);

const kpiRequiresVariable = computed(
  () => !isEmpty(formData.kpi?.variableValues),
);

const kpiRequiresSource = computed(() => {
  if (formData.kpi === null) {
    return false;
  }
  return [
    CareAlertMetric.ErrorCountBySource,
    CareAlertMetric.WarningCountBySource,
  ].includes(formData.kpi.kpi);
});

const kpiRequiresEventCode = computed(() => {
  if (formData.kpi === null) {
    return false;
  }
  return [CareAlertMetric.ErrorCount, CareAlertMetric.WarningCount].includes(
    formData.kpi!.kpi,
  );
});

const alertCount = computed(() => formData.devices.length);

return { __sfc: true,emit, formData, t, onKpiSelectionFormInput, onSubmit, onVariableSelectionEnter, onSourceSelectionEnter, selectedTenantIds, kpiRequiresVariable, kpiRequiresSource, kpiRequiresEventCode, alertCount, Wizard, CustomersListSelectorWizardStep, EquipmentListSelectorWizardStep, KpiSelectionFormWizardStep, VariableSelectionFormWizardStep, SourceSelectionFormWizardStep, EventCodesSelectionFormWizardStep }
}

})